<template>
  <div>
    <div class=" d-flex justify-content-end col-8" v-if="can_add">
      <a href="#" class="btn btn--green" @click="openAddSkillsSidebar()">
        {{ __("misc.add") }}</a>
    </div>
    <div class="row mb-5" v-if="show_coverage_rate_skills">
      <div class="card border-card shadow p-2 col-4 mr-4" v-for="roleSkills in dataSkills.skillsByRole">
        <p v-if="typology_name">
          {{ __("views.PeopleSkills.typologyCoverAgeRatePrefix") }} "{{ typology_name }}" {{ __("views.PeopleSkills.typologyCoverAgeRateOf") }}: {{ roleSkills.role.name }}
        </p>
        <p v-else>{{ __("views.PeopleSkills.positionCoverAgeRate") }}: {{ roleSkills.role.name }}</p>
        <p class="text-right">{{ roleSkills.positionCoverRate }} %</p>
      </div>
    </div>

    <div v-if="tableUpdated" class="alert alert-warning" role="alert">
      <div class="d-flex form-buttons" v-if="can_update">
        <p v-if="tableUpdated"> {{ __("forms.Skill.saveChange") }}</p>
        <button v-if="tableUpdated"
          class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove ml-1" type="button"
          @click="discardUpdates()">
          <i class="fa-solid fa-times"></i></button>
        <button v-if="tableUpdated"
          class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit ml-1" type="button"
          @click="confirmUpdates()">
          <i class="fa-solid fa-check"></i></button>
      </div>
    </div>
    <hr>
    <section>
      <div v-if="dataSkills.skillsByRole.length">
        <h3>{{ __('views.PeopleSkills.roleSkills') }}</h3>
        <div v-for="roleSkills in dataSkills.skillsByRole">

          <h3>{{ roleSkills.role.name }}</h3>
          <table class="table table-condensed">
            <thead>
              <tr>
                <th width="40%">Skill</th>
                <th width="20%">{{ __("views.People.requested_level") }}</th>
                <th width="20%">{{ __("views.People.personal_level") }}</th>
                <th width="20%" v-if="can_approve"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in roleSkills.tableRoleSkills">
                <td>
                  {{ row.skillName }}
                  <span v-if="!typology_name && row.typologyInitial"
                    class="badge badge-pill"
                    :style="{ backgroundColor: typologyColor(row.typologyId), color: '#fff' }"
                  >{{ row.typologyInitial }}</span>
                </td>
                <td>{{ row.skillRoleLevel }}</td>
                <td>
                  <select :disabled="!can_update" v-model="row.personSkillLevelId" class="form-control"
                    @change="setEditTrue($event, row)">
                    <option>---</option>
                    <option v-for="level in levels" :value="level.id" v-html="level.title">
                    </option>
                  </select>
                </td>
                <td class="d-flex">

                  <button v-if="can_view_history && row.personSkillId !== null"
                    class="btn btn--mini btn--only-icon btn--blue circle-button circle-button-link mx-1 prm-btn"
                    @click="historyPersonSkill(row.personSkillId)">
                    <i class="fa-solid fa-arrows-rotate"></i>
                  </button>

                  <button v-if="can_delete" @click="deletePersonSkill(row)"
                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1">
                    <i class="fas fa-trash"></i>
                  </button>

                  <button v-if="can_approve && row.personSkillId !== null"
                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1"
                    :title='__("forms.SkillsRoles.approve")' @click="approvePersonalSkill(row.personSkillId)">
                    <i class="fa-solid fa-thumbs-up"></i>
                  </button>

                </td>


              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="dataSkills.personalSkills.length">
        <h3>{{ __('views.PeopleSkills.personalSkills') }}</h3>
        <table class="table table-condensed">
          <thead>
            <tr>
              <th width="40%">Skill</th>
              <th width="20%">{{ __("views.People.requested_level") }}</th>
              <th width="20%">{{ __("views.People.personal_level") }}</th>
              <th width="20%" v-if="can_approve"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in dataSkills.personalSkills">
              <td>
                {{ row.skillName }}
                <span v-if="!typology_name && row.typologyInitial"
                  class="badge badge-pill"
                  :style="{ backgroundColor: typologyColor(row.typologyId), color: '#fff' }"
                >{{ row.typologyInitial }}</span>
              </td>
              <td>{{ row.skillRoleLevel }}</td>
              <td>
                <select :disabled="!can_update" v-model="row.personSkillLevelId" class="form-control"
                  @change="setEditTrue($event, row)">
                  <option>---</option>
                  <option v-for="level in levels" :value="level.id" v-html="level.title">
                  </option>
                </select>
              </td>
              <td class="d-flex">

                <button v-if="can_view_history && row.personSkillId !== null"
                  class="btn btn--mini btn--only-icon btn--blue circle-button circle-button-link mx-1 prm-btn"
                  @click="historyPersonSkill(row.personSkillId)">
                  <i class="fa-solid fa-arrows-rotate"></i>
                </button>

                <button v-if="can_delete" @click="deletePersonSkill(row)"
                  class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1">
                  <i class="fas fa-trash"></i>
                </button>

                <button v-if="can_approve && row.personSkillId !== null"
                  class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1"
                  :title='__("forms.SkillsRoles.approve")' @click="approvePersonalSkill(row.personSkillId)">
                  <i class="fa-solid fa-thumbs-up"></i>
                </button>

              </td>


            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
const TYPOLOGY_COLORS = ['#1767a2', '#2a9d8f', '#e76f51', '#8338ec', '#f4a261'];

export default {
  data() {
    return {
      dataSkills: {
        skillsByRole: [],
        personalSkills: []
      },
      newPersonSkillLevelId: null,
      newPersonSkillId: null,
      userUrl: this.is_admin ? "" : "-user",
      tableUpdated: false,
      typologyColorMap: {},
    };
  },
  methods: {
    typologyColor(typologyId) {
      if (typologyId === null || typologyId === undefined) return '#6c757d';
      if (!this.typologyColorMap[typologyId]) {
        const index = Object.keys(this.typologyColorMap).length % TYPOLOGY_COLORS.length;
        this.$set(this.typologyColorMap, typologyId, TYPOLOGY_COLORS[index]);
      }
      return this.typologyColorMap[typologyId];
    },
    setEditTrue(event, skillPersonRow) {

      //Set tableUpdate,
      this.tableUpdated = true;

      //cycle all personal skills, if we find the same skill, copy on all the same skill level
      this.dataSkills.skillsByRole.forEach(role => {
        role.tableRoleSkills.forEach(skill => {
          if (skillPersonRow.id === skill.id) {
            skill.personSkillLevelId = event.target.value;
          }
        });
      });
   
    },
    setEditFalse() {
      this.tableUpdated = false;
    },
    checkEditStatus() {
      return this.tableUpdated;
    },

    deletePersonSkill(row) {
      if (this.checkEditStatus()) {
        Vue.swal.fire({
          title: "Sono presenti delle modifiche sulle skills",
          text: "Salva il loro contenuto prima di continuare",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
        return;
      }

      Vue.swal
        .fire({
          title: "Vuoi eliminare questa skill?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Elimina",
        })
        .then((result) => {
          if (result.value) {
            axios
              .delete("/people-skill" + this.userUrl + "/" + row.personSkillId)
              .then((response) => {
                this.populateSkillTable();
              });
          }
        });
    },
    openAddSkillsSidebar() {
      if (this.checkEditStatus()) {
        Vue.swal.fire({
          title: "Sono presenti delle modifiche sulle skills",
          text: "Salva il loro contenuto prima di continuare",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      app.__vue__.$refs.vue_sidebar.toggle(
        "/people-skills-bulk-create/" + this.person + "/person/" + (this.typology_id ? "?typology_id=" + this.typology_id : "")
      );
    },
    historyPersonSkill(id) {
      if (this.checkEditStatus()) {
        Vue.swal.fire({
          title: "Sono presenti delle modifiche sulle skills",
          text: "Salva il loro contenuto prima di continuare",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      app.__vue__.$refs.vue_popup.toggle("Storico", "/registry-people-skill/" + id);
    },

    updatePersonSkill() {
      axios
        .put("/people-skill-profile" + this.userUrl + "/", {
          dataSkills: this.dataSkills,
          person_id: this.person,
        })
        .then((response) => {
          this.populateSkillTable();
        });
    },

    approvePersonalSkill(personSkillId) {
      if (!this.can_approve) {
        return;
      }
      if (this.checkEditStatus()) {
        Vue.swal.fire({
          title: "Sono presenti delle modifiche sulle skills",
          text: "Salva il loro contenuto prima di continuare",
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
        return;
      }
      Vue.swal
        .fire({
          title: "Are you sure?",
          text: "You want approve this personal skill?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, approve it!",
        })
        .then((result) => {
          if (result.value) {
            axios
              .put(
                "/registry-people-skill" +
                this.userUrl +
                "/" +
                personSkillId +
                "/approve"
              )
              .then((response) => {
                this.populateSkillTable();
              });
          }
        });
    },
    discardUpdates() {
      this.populateSkillTable();
    },
    confirmUpdates() {
      this.updatePersonSkill();
    },
    populateSkillTable() {
      const url = "/skills-for-person/" + this.person + "/person"
        + (this.typology_id ? "?typology_id=" + this.typology_id : "");
      axios
        .get(url)
        .then((response) => {
          this.dataSkills = response.data;
          this.setEditFalse();
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
  mounted() {
    this.populateSkillTable();
  },
  props: {
    person: {
      type: Number,
      required: true,
    },
    skills: {
      type: Array,
      required: true,
    },
    levels: {
      type: Array,
      required: true,
    },
    can_approve: {
      type: Boolean,
      required: true,
    },
    can_update: {
      type: Boolean,
      required: true,
    },
    is_admin: {
      type: Boolean,
      required: true,
    },
    show_coverage_rate_skills: {
      type: Boolean,
      required: true,
    },
    only_read: {
      type: Boolean,
      required: true,
    },
    can_add: {
      type: Boolean,
      required: true,
    },
    can_delete: {
      type: Boolean,
      required: true,
    },
    can_view_history: {
      type: Boolean,
      required: true,
    },
    typology_id: {
      type: Number,
      default: null,
    },
    typology_name: {
      type: String,
      default: null,
    },
  },
};
</script>
<style>
.new-skill-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>